import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ResponseResult } from '@softline/core';
import { ArtikelMenge, Lagerplatz, LagerplatzInhalt } from '@softapps/lager/core';
import { FinalizeProductRelocationBody } from '../types/finialize';
import {
  SOFTLINE_API_LAGER_AVAILABLE_STORAGE_LOCATIONS,
  SOFTLINE_API_LAGER_FINALIZE,
  SOFTLINE_API_LAGER_SCAN_PALLET,
} from '../product-relocation.api';

@Injectable()
export class ProductRelocationRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  async findPallet(code: string): Promise<LagerplatzInhalt> {
    return (
      await this.#dataAccess.get<ResponseResult<LagerplatzInhalt>>({
        path: SOFTLINE_API_LAGER_SCAN_PALLET,
        pathParams: { code },
      })
    )?.result;
  }

  async availableStorageLocations(body: ArtikelMenge): Promise<Lagerplatz[]> {
    return (
      await this.#dataAccess.create<ArtikelMenge, ResponseResult<LagerplatzInhalt[]>>(
        {
          path: SOFTLINE_API_LAGER_AVAILABLE_STORAGE_LOCATIONS,
        },
        body
      )
    )?.result?.map((o) => o.lagerplatz);
  }

  async finalize(body: FinalizeProductRelocationBody): Promise<LagerplatzInhalt> {
    return (
      await this.#dataAccess.create<FinalizeProductRelocationBody, ResponseResult<any>>(
        {
          path: SOFTLINE_API_LAGER_FINALIZE,
        },
        body
      )
    )?.result;
  }
}
